<template>
  <div class="step__blocks">
    <div class="s-block">
      <div class="s-text">
        <div class="s-text__txt" v-html="description"></div>
        <div v-show="disabled" class="s-text__warning s-text__warning--blue">Значение автоматически
                                                                             высчитывается в
                                                                             зависимости от
                                                                             размеров
                                                                             поддона.
        </div>
        <div v-show="needPrevDouble && this.item.UF_SOLID_PART === '1' && this.item.UF_DOUBLE_SOLID === '1'" class="s-text__warning">
          Ширина подвижной части двери превышает ширину глухой
          части двери. Вернитесь на
          предыдущие шаги
          и измените размеры.
        </div>
        <div v-show="autoPartMaxBigger" class="s-text__warning">
          {{ this.title }} должна
          быть меньше
          {{
            item.UF_TOP_LIMIT
          }} мм. Вернитесь на
          предыдущие шаги
          и измените размеры.
        </div>
        <div v-show="needPrevSolid && this.item.UF_SOLID_PART === '1' && this.item.UF_SOLID_WARNING !== '1'" class="s-text__warning">
          {{ this.title }} должна
          быть больше
          {{
            item.UF_BOTTOM_LIMIT
          }} мм. Вернитесь на
          предыдущие шаги
          и измените размеры.
        </div>
      </div>
      <div class="s-range" :class="{'disabled':disabled || needPrev || autoPart || !canChange}">
        <div class="s-range__slider">
          <div v-show="item.UF_BOTTOM_LIMIT && item.UF_TOP_LIMIT" class="s-range__left">
            <Veeno ref="veeno" :connect="'lower'" :step="1" :handles="[val]" :range="range" v-model="val" @change="sliderChange"/>
            <div class="s-range__text">
              <div v-show="this.item.UF_BOTTOM_LIMIT" class="s-range__text-min">{{ Number(item.UF_BOTTOM_LIMIT) }} мм
              </div>
              <div v-show="this.item.UF_STANDART" class="s-range__text-standart" @click="reset">Стандартное значение
              </div>
              <div v-show="this.item.UF_TOP_LIMIT" class="s-range__text-max">{{ Number(item.UF_TOP_LIMIT) }} мм
              </div>
            </div>
          </div>
          <div class="s-inputs">
            <div class="default-input">
              <input class="default-input__input" type="number" :disabled="disabled || needPrev || autoPart || !canChange" @change="inputVal" v-model="valueInput">
              <label class="default-input__label">мм</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="item.PICTURE" class="s-img">
      <img :src="item.PICTURE ? item.PICTURE.src : ''" alt="Изображение" loading="lazy">
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";
import Veeno                  from "veeno";

export default {
  name  : "RangeSliderTest",
  props : ["number", "item", "parent", "template", "description", "title"],
  data()
  {
    return {
      val            : 0,
      valueInput     : 0,
      range          : {
        "min" : Number(this.item.UF_BOTTOM_LIMIT) > 0 ? Number(this.item.UF_BOTTOM_LIMIT) : (this.item.UF_STANDART ? parseInt(this.item.UF_STANDART) : 0),
        "max" : Number(this.item.UF_TOP_LIMIT) > 0 ? Number(this.item.UF_TOP_LIMIT) : (this.item.UF_STANDART ? parseInt(this.item.UF_STANDART) + 1 : 10000)
      },
      needPrevDouble : false,
      needPrevSolid  : false
    };
  },
  components : {
    Veeno
  },
  computed   : {
    ...mapState([
      "moduleConfigurator"
    ]),
    autoPartMaxBigger()
    {
      return this.autoPart && this.item.UF_TOP_LIMIT && this.val > this.item.UF_TOP_LIMIT;
    },
    disabled()
    {
      return (this.moduleConfigurator.changeSizes.panel > 0 && this.item.UF_WIDTH === "1") ||
             (this.moduleConfigurator.changeSizes.door > 0 && this.item.UF_DOOR === "1");
    },
    needPrev()
    {
      return (this.needPrevSolid || this.needPrevDouble) && this.autoPart;
    },
    autoPart()
    {
      return this.item.UF_SOLID_PART === "1";
    },
    autoPartDisabling()
    {
      return this.autoPart && (this.moduleConfigurator.changeSizes.panel > 0 || this.moduleConfigurator.changeSizes.door > 0);
    },
    canChange()
    {
      return Boolean(this.item.UF_BOTTOM_LIMIT || this.item.UF_TOP_LIMIT);
    }
  },
  watch      : {
    "val"()
    {
      if(this.autoPart)//без этого не проставляется глухая часть после обновления страницы
      {
        this.val = this.moduleConfigurator.solidPart;
        // this.setSelect();
      }

      this.val        = Math.round(parseInt(this.val));
      this.valueInput = Math.round(this.val);

      let needDisable = false;
      if(this.autoPartMaxBigger)
      {
        needDisable = true;
      }
      else
      {
        if(needDisable) //если шаг был сброшен
        {
          this.setSelect();
        }
      }

      if(this.needPrevSolid === true && this.item.UF_SOLID_WARNING !== "1") //если нельзя пропускать на следующий шаг, то сбрасываем значение шага
      {
        needDisable = true;
      }
      else //иначе устанавливаем значение
      {
        this.needPrevSolid = false;
        if(needDisable) //если шаг был сброшен
        {
          this.setSelect();
        }
      }
      if(this.needPrevDouble === true && this.autoPart && this.item.UF_DOUBLE_SOLID === "1") //если нельзя пропускать на следующий шаг, то сбрасываем значение шага
      {
        needDisable = true;
      }
      else //иначе устанавливаем значение
      {
        this.needPrevDouble = false;
        if(needDisable) //если шаг был сброшен
        {
          this.setSelect();
        }
      }

      this.moduleConfigurator.steps[this.number - 1]["DISABLED"] = needDisable;

      if(this.item.UF_WIDTH === "1")
      {
        this.moduleConfigurator.width = this.moduleConfigurator.changeSizes.panel > 0 ? this.moduleConfigurator.changeSizes.panel : this.val;
      }
      if(this.item.UF_DOOR === "1")
      {
        this.moduleConfigurator.door = this.moduleConfigurator.changeSizes.door > 0 ? this.moduleConfigurator.changeSizes.door : this.val;
        this.moduleConfigurator.solidPart
                                     = (this.moduleConfigurator.door ?? this.moduleConfigurator.changeSizes.door) - this.moduleConfigurator.doorPanel - this.moduleConfigurator.doublePart;
      }
      if(this.item.UF_DOUBLE_PART === "1")
      {
        this.moduleConfigurator.doublePart = this.val;
        this.needPrevDouble                = this.moduleConfigurator.doublePart > this.moduleConfigurator.solidPart;
        this.moduleConfigurator.solidPart
                                           = (this.moduleConfigurator.door ?? this.moduleConfigurator.changeSizes.door) - this.moduleConfigurator.doorPanel - this.moduleConfigurator.doublePart;
      }
      if(this.item.UF_DOOR_PANEL === "1")
      {
        this.moduleConfigurator.doorPanel = this.val;
        this.moduleConfigurator.solidPart
                                          = (this.moduleConfigurator.door ?? this.moduleConfigurator.changeSizes.door) - this.moduleConfigurator.doorPanel - this.moduleConfigurator.doublePart;
      }
      if(this.item.UF_SOLID_PART === "1")
      {
        this.val = this.moduleConfigurator.solidPart;
      }
    },
    "$store.state.moduleConfigurator.changeSizes.door"()
    {
      if(this.item.UF_DOOR !== "1")
      {
        return;
      }
      if(this.moduleConfigurator.changeSizes.door > 0)//если сторона рассчитывается автоматически
      {
        this.moduleConfigurator.lastChanges.door = this.val;//записываем последнее значение
        this.val                                 = this.moduleConfigurator.changeSizes.door;//меняем текущее значение на автоматически рассчитанное
        this.moduleConfigurator.solidPart
                                                 = (this.moduleConfigurator.door ?? this.moduleConfigurator.changeSizes.door) - this.moduleConfigurator.doorPanel - this.moduleConfigurator.doublePart;
      }
      if(this.moduleConfigurator.changeSizes.door === 0 && this.moduleConfigurator.lastChanges.door > 0)//если сторона была рассчитана автоматически, но теперь не должна рассчитываться
      {
        this.val = this.moduleConfigurator.lastChanges.door;//восстанавливаем последнее значение
      }
      this.setSelect();
    },
    // "$store.state.moduleConfigurator.changeSizes.width"()
    // {
    //   if(this.item.UF_WIDTH !== "1")
    //   {
    //     return;
    //   }
    //   if(this.moduleConfigurator.changeSizes.width > 0)//если сторона рассчитывается автоматически
    //   {
    //     this.moduleConfigurator.lastChanges.width = this.val;//записываем последнее значение
    //     this.val                                  = this.moduleConfigurator.changeSizes.width;//меняем текущее значение на автоматически рассчитанное
    //   }
    //   if(this.moduleConfigurator.changeSizes.width === 0 && this.moduleConfigurator.lastChanges.width > 0)//если сторона была рассчитана автоматически, но теперь не должна рассчитываться
    //   {
    //     this.val = this.moduleConfigurator.lastChanges.width;//восстанавливаем последнее значение
    //   }
    //   this.setSelect();
    // },
    "$store.state.moduleConfigurator.changeSizes.panel"()
    {
      if(this.item.UF_WIDTH !== "1")
      {
        return;
      }
      if(this.moduleConfigurator.changeSizes.panel > 0)//если сторона рассчитывается автоматически
      {
        this.moduleConfigurator.lastChanges.panel = this.val;//записываем последнее значение
        this.moduleConfigurator.width             = this.moduleConfigurator.changeSizes.panel;//меняем текущее значение на автоматически рассчитанное
      }
      if(this.moduleConfigurator.changeSizes.panel === 0 && this.moduleConfigurator.lastChanges.panel > 0)//если сторона была рассчитана автоматически, но теперь не должна рассчитываться
      {
        this.val = this.moduleConfigurator.lastChanges.panel;//восстанавливаем последнее значение
      }
      this.setSelect();
    },
    "$store.state.moduleConfigurator.width"()
    {
      if(this.item.UF_WIDTH !== "1" || !this.disabled)
      {
        return;
      }
      this.val            = this.moduleConfigurator.width;

      this.setSelect();
    },
    "$store.state.moduleConfigurator.solidPart"()
    {
      if(this.item.UF_SOLID_PART !== "1")
      {
        return;
      }
      this.val            = this.moduleConfigurator.solidPart;
      this.needPrevSolid  = this.moduleConfigurator.solidPart < Number(this.item.UF_BOTTOM_LIMIT);
      this.needPrevDouble = this.moduleConfigurator.doublePart > this.moduleConfigurator.solidPart;

      this.setSelect();
    }
  },
  methods    : {
    ...mapActions([
      "SET_SELECT"
    ]),
    reset()
    {
      this.$refs.veeno.$el.noUiSlider.set(Number(this.item.UF_STANDART));
      this.setSelect();
    },
    sliderChange()
    {
      this.$refs.veeno.$el.noUiSlider.set(this.val);
      this.setSelect();
    },
    inputVal()
    {
      if(this.disabled || this.needPrev || this.autoPartDisabling || !this.canChange)
      {
        return;
      }
      this.checkLimits();
      this.val = this.valueInput;
      this.setSelect();
    },
    checkLimits()
    {
      if(parseInt(this.valueInput) > parseInt(this.item.UF_TOP_LIMIT))
      {
        this.valueInput = parseInt(this.item.UF_TOP_LIMIT);
        window.toast.error("Максимальное значение: " + this.item.UF_TOP_LIMIT);
      }
      if(parseInt(this.valueInput) < parseInt(this.item.UF_BOTTOM_LIMIT))
      {
        this.valueInput = parseInt(this.item.UF_BOTTOM_LIMIT);
        window.toast.error("Минимальное значение: " + this.item.UF_BOTTOM_LIMIT);
      }
    },
    setSelect()
    {
      if(this.$refs.veeno)
      {
        this.$refs.veeno.$el.noUiSlider.set(this.val);
      }

      this.SET_SELECT({
        index : parseInt(this.number) - 1,
        name  : Math.round(this.val) + " мм",
        id    : this.item["ID"]
      });

    }
  },
  created()
  {
    this.moduleConfigurator.rInd++;

    if(this.moduleConfigurator.door > 0 && this.item.UF_DOOR === "1")
    {
      this.val = this.moduleConfigurator.door;
    }
    if(this.moduleConfigurator.width > 0 && this.item.UF_WIDTH === "1")
    {
      this.val = this.moduleConfigurator.width;
    }
    if(this.moduleConfigurator.doublePart > 0 && this.item.UF_DOUBLE_PART === "1")
    {
      this.val = this.moduleConfigurator.doublePart;
    }
    if(this.moduleConfigurator.doorPanel > 0 && this.item.UF_DOOR_PANEL === "1")
    {
      this.val = this.moduleConfigurator.doorPanel;
    }
    if(this.item.UF_SOLID_PART === "1")
    {
      this.val = this.moduleConfigurator.solidPart;
    }

    if(!this.val)
    {
      this.val = Number(this.item.UF_STANDART ?? this.item.UF_BOTTOM_LIMIT);
    }
    if(!this.moduleConfigurator.steps[this.number - 1]["showNext"])
    {
      this.setSelect();
    }
  }
};
</script>